import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('auth');
const LOGIN = define('LOGIN', true);
const LOGOUT = define('LOGOUT', true);
const GET_ME = define('GET_ME', true);

const initialState = {
  loggedIn: false,
  isCheckedLogin: false,
  user: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN.REJECTED:
      return { ...state, loggedIn: false };
    case LOGIN.RESOLVED:
      return {
        ...state,
        loggedIn: true,
        user: action.data.user,
      };
    case LOGOUT.RESOLVED:
      return { ...state, loggedIn: false, user: {} };
    case GET_ME.RESOLVED:
      return {
        ...state,
        loggedIn: action.data.isLoggedIn,
        user: action.data.user,
        isCheckedLogin: true,
      };
    case GET_ME.REJECTED:
      return { ...state, loggedIn: false, user: {}, isCheckedLogin: true };
    default: return state;
  }
};

export const actions = {
  login: ({ email, password }) => ({
    type: LOGIN,
    promise: (async () => {
      const resp = await api.post('/partner/auth/login', { email, password });
      if (resp.data.user && !resp.data.user.is_partner) throw new Error('Not a partner account');
      return resp;
    })(),
    success: 'Logged in successfully',
    error: 'Unable to authenticate'
  }),
  logout: () => ({
    type: LOGOUT,
    promise: api.delete('/partner/auth/logout'),
    success: 'Logged out successfully',
    error: 'Unable to logout',
  }),
  getMe: () => ({
    type: GET_ME,
    promise: api.get('/partner/auth/me')
  })
};



// WEBPACK FOOTER //
// ./src/modules/auth.js